export enum PhoneVerificationType {
  SMS = 'SMS',
  NOW_SMS = 'NOW_SMS',
  MANUAL = 'MANUAL',
  ADMIN = 'ADMIN'
}

export interface PhoneVerificationStatus {
  verificationType?: PhoneVerificationType | null;
  verifiedAt?: string | null;
  phoneNumber?: string | null;
}
